// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__1z7Kn","active":"Uploader_active__4BSD4"};